import script from "./BankAccountDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./BankAccountDetails.vue?vue&type=script&setup=true&lang=js"

import "./BankAccountDetails.vue?vue&type=style&index=0&id=740d4146&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-740d4146"]])

export default __exports__